import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import { ActiveClasses } from './subpages';
import './CourseManagement.css';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`course-tabpanel-${index}`}
      aria-labelledby={`course-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const CourseManagement: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ 
      // Use negative margins to counteract MainLayout padding and achieve full width
      mx: -3,
      // Add top margin to maintain spacing from PageHeader
      mt: 3
    }}>
      <PageHeader 
        title="Course Management" 
        subtitle="Manage active training courses and sessions"
      />
      
      {/* Full-width tabs container */}
      <Box sx={{ 
        borderBottom: 1, 
        borderColor: 'divider',
        px: 3  // Add padding back for tab content
      }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="course management tabs"
        >
          <Tab label="Active Classes" id="course-tab-0" aria-controls="course-tabpanel-0" />
          {/* Future tabs can be added here */}
          {/* <Tab label="Course Scheduling" id="course-tab-1" aria-controls="course-tabpanel-1" /> */}
          {/* <Tab label="Reports" id="course-tab-2" aria-controls="course-tabpanel-2" /> */}
        </Tabs>
      </Box>

      {/* Tab content - full width */}
      <TabPanel value={tabValue} index={0}>
        <ActiveClasses />
      </TabPanel>
      
      {/* Future tab panels */}
      {/* <TabPanel value={tabValue} index={1}>
        <CourseScheduling />
      </TabPanel>
      <TabPanel value={tabValue} index={2}>
        <CourseReports />
      </TabPanel> */}
    </Box>
  );
};

export default CourseManagement;
